module.exports = __webpack_public_path__ + "img/uwzorgonline-logo@3x.3f88c735.png";